import Client from '@/repositories/clients/AuthenticatedClient';

/**
 * ToolRunsRepository — HTTP access for the unified tool-runs feed + pin
 * actions against `/tools`.
 *
 * Endpoints:
 *   GET    /tools/runs                  → { items: ToolRun[], pinned_tools: string[] }
 *   POST   /tools/:toolKey/pin          → { pinned_tools: string[], ... }
 *   DELETE /tools/:toolKey/pin          → { pinned_tools: string[], ... }
 *
 * Conventions:
 * - Uses the shared `AuthenticatedClient`; its baseURL already includes the
 *   `/api/v2` prefix.
 * - Methods return the raw axios response; the service unwraps `.data` and
 *   mirrors it into its module-level refs.
 */
const RUNS_PATH = '/tools/runs';
const TOOL_PATH = '/tools';

export default {
  /**
   * Load the tool-runs feed.
   * @param {{ category?: string|null, limit?: number }} params
   * @returns {Promise<import('axios').AxiosResponse>} raw response;
   *          `.data.items` + `.data.pinned_tools`.
   */
  async loadRuns({ category = null, limit = 100 } = {}) {
    return Client.get(RUNS_PATH, { params: { category, limit } });
  },

  /**
   * Pin a tool.
   * @param {string} toolKey
   * @returns {Promise<import('axios').AxiosResponse>} raw response; `.data.pinned_tools`.
   */
  pin(toolKey) {
    return Client.post(`${TOOL_PATH}/${encodeURIComponent(toolKey)}/pin`);
  },

  /**
   * Unpin a tool.
   * @param {string} toolKey
   * @returns {Promise<import('axios').AxiosResponse>} raw response; `.data.pinned_tools`.
   */
  unpin(toolKey) {
    return Client.delete(`${TOOL_PATH}/${encodeURIComponent(toolKey)}/pin`);
  },
};
